<template>
  <div @click.stop="() => {}" :class="isMobile ? 'mobile-play-audio' : 'play-audio'">
    <div class="head">{{ languageOption.soundControl }}</div>
    <i class="el-dialog__close el-icon el-icon-close audio-close" v-if="isMobile" @click="handleCancel"></i>
    <div class="content">
      <div class="music-content" v-if="audioData.turnSound && showTurn">
        <span class="type">{{ languageOption.pageTurningSound }}:</span>
        <el-radio v-model="turnMusic" label="1" @change="confirmOnChange">{{ languageOption.on }}</el-radio>
        <el-radio v-model="turnMusic" label="0" @change="confirmOnChange">{{ languageOption.off }}</el-radio>
      </div>
      <div class="music-content" v-if="audioData.bgSound">
        <span class="type">{{ languageOption.backgroundMusic }}:</span>
        <el-radio v-model="bgMusic" label="1" @change="confirmOnChange">{{ languageOption.on }}</el-radio>
        <el-radio v-model="bgMusic" label="0" @change="confirmOnChange">{{ languageOption.off }}</el-radio>
      </div>
    </div>
    <div class="foot" v-if="!isMobile">
      <div class="confirm" @click="handlePlay">{{ languageOption.confirm }}</div>
      <div class="cancel" @click="handleCancel">{{ languageOption.cancel }}</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'playaudio',
  data() {
    return {
      turnMusic: '1',
      bgMusic: '1'
    }
  },
  props: {
    type: String,
    showTurn: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('book', ['isMobile']),
    audioData() {
      return this.$store.state.config.bookObj.audioData // 是否展示音乐图标
    },
    currentLang() {
      return this.$store.state.config.bookObj.language
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.currentLang]
    }
  },
  mounted() {
    // document.body.addEventListener('click', this.closeAudioShow)
  },
  beforeMount() {
    // document.body.removeEventListener('click', this.closeAudioShow)
  },
  methods: {
    closeAudioShow() {
      this.$emit('changeAudio', false)
    },
    handlePlay() {
      if (this.turnMusic === '1' && this.audioData.turnSound) {
        this.$store.commit('book/UPDATE_PLAY', true)
      } else {
        this.$store.commit('book/UPDATE_PLAY', false)
      }
      if (this.bgMusic === '1' && this.audioData.bgSound) {
        this.$emit('isPlayAudio', true)
      } else {
        this.$emit('isPlayAudio', false)
      }
      this.$emit('changeAudio')
    },
    handleCancel(e) {
      e.stopPropagation()
      this.$emit('changeAudio')
    },
    confirmOnChange() {
      // 移动端点击即生效
      if (this.isMobile) {
        this.handlePlay()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head {
  font-size: 14px;
  font-weight: 600;
  font-family: PingFangSC-Semibold, PingFang SC;
  text-align: center;
  color: #000;
}
.play-audio {
  width: 250px;
  height: 140px;
  background: #fff;
  position: absolute;
  top: -153px;
  left: 50%;
  transform: translateX(-50%);
  color: #515151;
  //z-index: ;
  .head {
    height: 40px;
    line-height: 20px;
    padding: 10px 0;
  }
  .content {
    height: 50px;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    /deep/ .el-radio {
      margin-right: 10px;
      .el-radio__label {
        padding-left: 3px;
        font-size: 12px;
      }
      .el-radio__input {
        .el-radio__inner {
          width: 12px;
          height: 12px;
        }
      }
    }
    .type {
      margin-right: 15px;
    }
  }
  .foot {
    height: 50px;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    div {
      width: 56px;
      height: 20px;
      color: #fff;
      font-size: 10px;
      line-height: 20px;
      text-align: center;
    }
    .confirm {
      background: #df5813;
      margin-right: 13px;
    }
    .cancel {
      background: #999999;
    }
  }
}
.mobile-play-audio {
  width: 100%;
  height: 120px;
  position: fixed;
  bottom: 57px;
  left: 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background: #fff;
  .head {
    width: 100%;
    height: 30px;
  }
  .audio-close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 13px;
    height: 13px;
    color: #606266;
  }
  .content {
    .music-content {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      /deep/ .el-radio {
        margin-right: 10px;
        .el-radio__label {
          padding-left: 3px;
          font-size: 13px;
        }
        .el-radio__input {
          .el-radio__inner {
            width: 13px;
            height: 13px;
          }
        }
      }
      .type {
        margin-right: 15px;
        color: #606266;
      }
    }
  }
}
</style>
